import {JacksonType} from "@sonner/jackson-service-v2";
import {PGDASDDASTO} from "./pgdasd.das.to";

@JacksonType("SqlInterativoTitle")
export class SqlInterativoTitle {

  data: string[];

}
